<template>
  <div class="trazabilidad-grafica" style="height: 600px;">
    <vue-flow ref="flow" :nodes="nodes" :edges="edges" :node-types="{ custom: true }"
      :fit-view-options="{ padding: 0.2 }">
      <template #node-custom="{ data }">
        <div :class="['nodo', data.clase]" @click="$emit('seleccionar', data)">
          <Handle type="target" position="left" />
          <div class="fw-bold d-flex justify-content-between align-items-center">
            {{ data.tipo }}
            <font-awesome-icon :icon="['fas', 'copy']" @click.stop="copiarCodigo(data.codigo)" title="Copiar Código"
              style="cursor:pointer;" />
          </div>
          <small class="d-block mb-1 text-light">{{ data.codigo }}</small>

          <div v-if="data.info">
            <div v-if="data.info.tipo || data.info.tipo_biomasa" class="text-light">
              <strong>Tipo:</strong> {{ data.info.tipo || data.info.tipo_biomasa }}
            </div>
            <div v-if="data.info.cantidad || data.info.peso || data.info.cantidad_unidades" class="text-light">
              <strong>Cantidad:</strong>
              {{ data.info.cantidad || data.info.peso || data.info.cantidad_unidades }}
              {{ data.info.unidad_medida || 'unidades' }}
            </div>
            <div
              v-if="data.info.fecha_inicio || data.info.fecha_cosecha || data.info.fecha_creacion || data.info.fecha_produccion || data.info.fecha_envasado"
              class="text-light">
              <strong>Fecha:</strong>
              {{ formatFecha(data.info.fecha_inicio || data.info.fecha_cosecha || data.info.fecha_creacion ||
                data.info.fecha_produccion || data.info.fecha_envasado) }}

            </div>
          </div>

          <Handle type="source" position="right" />
        </div>
      </template>

    </vue-flow>

    <!-- Popup info -->
    <div v-if="nodoSeleccionado" class="popup-info" @click="$emit('seleccionar', null)">
      <div class="popup-contenido" @click.stop>
        <h5>{{ nodoSeleccionado.tipo }} → {{ nodoSeleccionado.codigo }}</h5>
        <div v-if="nodoSeleccionado.info">
          <div v-for="(valor, clave) in nodoSeleccionado.info" :key="clave">
            <strong>{{ formatearClave(clave) }}:</strong> {{ valor }}
          </div>
        </div>
        <button @click="$emit('seleccionar', null)">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Handle, VueFlow } from "@vue-flow/core";

export default {
  name: "TrazabilidadGrafica",
  components: { VueFlow, Handle },
  props: {
    nodes: Array,
    edges: Array,
    nodoSeleccionado: Object
  },
  watch: {
    nodes() {
      this.ajustarZoom();
    },
    
  },

  methods: {
    copiarCodigo(codigo) {
      navigator.clipboard.writeText(codigo);
    },
    formatearClave(clave) {
      return clave.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
    formatearClase(tipo) {
      const t = tipo.toLowerCase();
      if (t.includes('lote')) return 'nodo lote';
      if (t.includes('biomasa')) return 'nodo biomasa';
      if (t.includes('materia prima')) return 'nodo materia-prima';
      if (t.includes('producto final bulk')) return 'nodo producto-final-bulk';
      if (t.includes('producto envasado')) return 'nodo producto-envasado';
      if (t.includes('no encontrado')) return 'nodo no-encontrado';
      return 'nodo default';
    },
    formatFecha(valor) {
      if (!valor) return '';
      const fecha = new Date(valor);
      return fecha.toLocaleDateString('es-AR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    },
    ajustarZoom() {
      this.$nextTick(() => {
        const flowInstance = this.$refs.flow?.fitView;
        if (flowInstance) flowInstance();
      });
    }



  }
};
</script>

<style scoped>
.vue-flow {
  width: 100%;
  height: 100%;
}

.nodo {
  padding: 8px;
  border-radius: 5px;
  font-size: 0.85rem;
  color: white;
}

.lote {
  background-color: #007bff;
}

.biomasa {
  background-color: #28a745;
}

.materia-prima {
  background-color: #a84e1a;
}

.producto-final-bulk {
  background-color: #205375;
}

.producto-envasado {
  background-color: #5a5a89;
}

.no-encontrado {
  background-color: #6c757d;
}

.popup-info {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-contenido {
  background: white;
  padding: 20px;
  border-radius: 10px;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
}

.nodo {
  padding: 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  line-height: 1.2;
  min-width: 200px;
  max-width: 240px;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.nodo strong {
  font-weight: 600;
}
</style>
